































import { Watch, Component, Prop, Vue } from 'vue-property-decorator'
import { BranchOperatingZoneAPI } from '@/api/backend-client'

@Component
export default class DeleteConfirmBranchOperatingZonesModal extends Vue {

    @Prop({ type: Boolean, default: false }) value!: boolean
    @Prop({ type: Array, default() { return [] } }) operatingZones!: string[]
    visible: boolean = false
    loading: boolean = false

    @Watch('value')
    onValueChanged(): void {
        this.visible = this.value
    }

    @Watch('visible')
    onVisibleChanged(): void {
        this.$emit('input', this.visible)
    }

    hideModal(): void {
        this.visible = false
    }

    async deleteOperatingZones(): Promise<void> {
        this.loading = true

        const promises = []

        this.operatingZones.forEach(operatingZone => {
            promises.push(BranchOperatingZoneAPI.delete(operatingZone))
        })

        await Promise.all(promises)
        this.hideModal()
        this.$emit('delete', this.operatingZones)

        this.loading = false
    }
}
